<div class="itineraries-form__image">
  <div *ngIf="label" class="itineraries-form__image--title">{{ label | translate }}</div>
  <div class="itinerary-course-image" [ngStyle]="{ 'background-image': cardImage ? 'url(' + cardImage + ')' : null }">
    <div *ngIf="cardImage" class="itinerary-course-image__actions">
      <button type="button" class="itinerary-course-image__button" (click)="modalZoomImage.open()">
        <span class="glicon-zoom"></span>
      </button>
      <button *lmsProfileGuard="action" type="button" class="itinerary-course-image__button" (click)="openModal()">
        <span class="glicon-pencil"></span>
      </button>
      <button *lmsProfileGuard="action" type="button" class="itinerary-course-image__button" (click)="removeImage()">
        <span class="glicon-trash"></span>
      </button>
    </div>

    <ng-container *lmsProfileGuard="action">
      <button *ngIf="!cardImage" type="button" class="itinerary-course-image__button" (click)="openModal()">
        <span class="glicon-pencil"></span>
      </button>
    </ng-container>
  </div>

  <lms-modal-splat #modalZoomImage class="modal-visor-image">
    <div class="gl-popup__close" (click)="modalZoomImage.close()">
      <span class="glicon-close"></span>
    </div>
    <div class="modal-visor-image__contain">
      <img [src]="cardImage" alt="image-cropper" />
    </div>
  </lms-modal-splat>

  <lms-modal-splat #modalImageSelector size="large">
    <div class="gl-popup__title">{{ 'actions.selectFile' | translate }}</div>
    <div class="gl-popup__close" (click)="closeModal()">
      <span class="glicon-close"></span>
    </div>
    <div class="gl-popup__scroll">
      <div dropzone (dropped)="onGetFile($event)" class="gl-popup__upload">
        <span *ngIf="!previewFile" class="glicon-upload-image"></span>
        <span *ngIf="!previewFile" class="label">{{ 'actions.dragAndDropImage' | translate }}</span>
        <span *ngIf="!previewFile" class="link">
          <label class="select-img-text" for="uploadImg" [innerHtml]="'actions.uploadImage' | translate"> </label>
          <input
            id="uploadImg"
            type="file"
            name="uploadImg"
            class="upload-img"
            accept="image/*"
            (change)="onGetFile($event)"
          />
        </span>
        <span class="separator"></span>
        <span *ngIf="!previewFile" class="label small">{{ 'actions.dragAndDropImageRecommended' | translate }}</span>
        <span *ngIf="!previewFile && !!maxSizeInMB" class="label small">{{
          'actions.dragAndDropMaxImageSize' | translate : { maxSizeInMB: this.maxSizeInMB }
        }}</span>
        <span *ngIf="!previewFile" class="label small">{{ 'actions.dragAndDropValidFiles' | translate }} </span>
        <image-cropper
          *ngIf="previewFile"
          [imageFile]="previewFile"
          [maintainAspectRatio]="false"
          format="png"
          output="base64"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed($event)"
        >
        </image-cropper>
      </div>
    </div>
    <div class="gl-popup__buttons padding-top__large">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="closeModal()"></gl-button>
      <gl-button color-primary [text]="'actions.save' | translate" [disabled]="!previewFile" (onClick)="changeImage()">
      </gl-button>
    </div>
  </lms-modal-splat>
</div>
